import { FC, memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PATH_LOGIN } from 'const';
import { SubmitButtonForm } from 'components/FieldsForm';
import {
  Error404Cloud1,
  Error404Cloud2,
  Error404Cloud3,
  Error404Flover,
  Error404Logo,
  Error404Moon,
  Error404TrafficCone,
} from 'assets/img';

import './style.scss';

export const Error404: FC = memo(() => {
  const { t } = useTranslation();

  const history = useHistory();

  const goLinkHandler = () => {
    history.push(PATH_LOGIN);
  };

  return (
    <div className="page-not-found__container">
      <div className="container page-not-found__wrapper ">
        <div className="page-not-found">
          <div className="page-not-found__header">
            <div className="page-not-found__item">
              <Error404Moon className="icon-background icon-background-moon icon-hidden" />
            </div>
            <div className="page-not-found__item">
              <Error404Logo className="icon-logo" />
            </div>
            <div className="page-not-found__item">
              <Error404Cloud2 className="icon-background icon-background-cloud-2 icon-hidden" />
            </div>
          </div>
          <div className="page-not-found__main">
            <div className="page-not-found__main-wrapper">
              <div className="page-not-found__item">
                <Error404Cloud1 className="icon-background icon-background-cloud-1 icon-hidden" />
              </div>
              <div className="page-not-found__item page-not-found__center-block">
                <h1>{t('error_404_title')}</h1>
              </div>
              <div className="page-not-found__item">
                <Error404Cloud3 className="icon-background icon-background-cloud-3 icon-hidden" />
              </div>
            </div>
            <div className="page-not-found__button">
              <SubmitButtonForm
                name={t('error_404_button_text')}
                type="button"
                onClick={goLinkHandler}
              />
            </div>
          </div>

          <div className="page-not-found__footer">
            <div className="page-not-found__item">
              <Error404Flover className="icon-background icon-background-flower icon-hidden" />
            </div>
            <div className="page-not-found__item">
              <Error404TrafficCone className="icon-background icon-background-trafficcone" />
            </div>
          </div>
          <div className="page-not-found__bg"></div>
        </div>
      </div>
    </div>
  );
});
